import React from 'react';
import { Message } from '@iwoca/orion';
import { LayoutHeadings } from 'components/Layout/InnerLayout/LayoutHeadings/LayoutHeadings';
import { ComparisonTable } from '../ComparisonTable/ComparisonTable';
import sharedStyles from '../Products.module.css';
import styles from './DocumentRequirements.module.css';

export const DocumentRequirements = () => {
  return (
    <div className={sharedStyles.section}>
      <LayoutHeadings
        heading="Document requirements"
        headingVariant="long"
        subHeading="Instant decision available up to £100K"
        headingAlignment="center"
      />

      <div className={styles.tableWrapper}>
        <ComparisonTable
          data={[
            {
              range: '£0 - £25,000',
              // TODO: Uncomment and/or update detailedLoanPurpose when final decision is made
              // detailedLoanPurpose: 'Optional',
              bankStatements: (
                <Message
                  type="success"
                  message="Not required"
                  className={styles.notRequired}
                />
              ),
              filedCompanyAccounts: (
                <Message
                  type="success"
                  message="Not required"
                  className={styles.notRequired}
                />
              ),
            },
            {
              range: '£25,001 - £75,000',
              // detailedLoanPurpose: 'Required',
              bankStatements: '6 months',
              filedCompanyAccounts: (
                <Message
                  type="success"
                  message="Not required"
                  className={styles.notRequired}
                />
              ),
            },
            {
              range: '£75,001 - £150,000',
              // detailedLoanPurpose: 'Required',
              bankStatements: '6 months',
              filedCompanyAccounts: 'Required',
            },
            {
              range: '£150,001 - £1,000,000',
              // detailedLoanPurpose: 'Required',
              bankStatements: '6 months',
              filedCompanyAccounts: 'Required',
            },
          ]}
          labels={{
            range: 'Requirements',
            // detailedLoanPurpose: 'Detailed loan purpose',
            bankStatements: 'Bank statements',
            filedCompanyAccounts: 'Filed company accounts',
          }}
        />
      </div>

      <div>
        <ul className={styles.infoList}>
          <li className={styles.infoListItem}>
            <span>-</span>
            <span>
              Bank statements should be PDFs, preferably downloaded from online
              banking
            </span>
          </li>
          <li className={styles.infoListItem}>
            <span>-</span>
            <span>
              Supporting information is always welcome, as we may ask for
              additional information for certain applications
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};
